import c from "swr";
const a = 1e3 * 60 * 60, l = 1e3 * 60 * 5;
let o = null, s = 0, e = null;
async function i() {
  if (o && Date.now() < s)
    return o;
  if (e)
    return e;
  e = (async () => {
    const u = process.env.NEXT_PUBLIC_BASE_PATH ?? "", t = await fetch(`${u}/api/proxy/maps-token`);
    if (!t.ok)
      throw new Error(`Failed to fetch Azure Maps token: ${t.status} ${t.statusText}`);
    const n = await t.json(), r = typeof (n == null ? void 0 : n.token) == "string" ? n.token.trim() : "";
    if (!r)
      throw new Error("Invalid Azure Maps token received from API");
    return o = r, s = Date.now() + Math.max(a - l, 0), r;
  })();
  try {
    return await e;
  } finally {
    e = null;
  }
}
const f = () => i();
function p() {
  return c("azureMapsToken", f, {
    dedupingInterval: a,
    refreshInterval: a,
    revalidateIfStale: !1,
    revalidateOnFocus: !1,
    revalidateOnReconnect: !1
  });
}
async function T() {
  return i();
}
export {
  T as g,
  p as u
};
